module.exports = __webpack_public_path__ + "static/media/nps+.bb8a2fe0.png";